<template>
  <span>
    <img v-if="user.image" :src="baseUrl + user.image.thumb" class="user-photo" />
    <v-gravatar v-else :email="user.email" default-img="mp" class="user-photo" />
  </span>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      default: () => null
    }
  }
}
</script>
<style lang="sass" scoped>
  img
    max-width: 100px
    border-radius: 15px
    border: 1px solid #f0f0f0
</style>
